/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

(() => {
  const fallbackScript = document.querySelector('script[data-rdr-guenstiger-bundle-fallback]');
  const bundleCopy = {
    label: fallbackScript?.dataset.bundleLabel || '',
    title: fallbackScript?.dataset.bundleTitle || '',
    intro: fallbackScript?.dataset.bundleIntro || '',
    type: fallbackScript?.dataset.bundleType || '',
    cta: fallbackScript?.dataset.bundleCta || '',
  };
  const fallbackBundles = {
    '/products/microsoft-office-2024-professional-plus-guenstiger-de': [
      ['microsoft-windows-11-home-office-2024-professional-plus', 'Windows 11 Home + Office 2024 Professional Plus'],
      ['microsoft-windows-11-pro-office-2024-professional-plus', 'Windows 11 Pro + Office 2024 Professional Plus'],
    ],
    '/products/microsoft-office-2021-professional-plus-guenstiger-de': [
      ['microsoft-windows-11-home-office-2021-professional-plus', 'Windows 11 Home + Office 2021 Professional Plus'],
      ['microsoft-windows-11-pro-office-2021-professional-plus', 'Windows 11 Pro + Office 2021 Professional Plus'],
    ],
    '/products/microsoft-office-2019-professional-plus-guenstiger-de': [
      ['microsoft-windows-11-home-office-2019-professional-plus', 'Windows 11 Home + Office 2019 Professional Plus'],
      ['microsoft-windows-11-pro-office-2019-professional-plus', 'Windows 11 Pro + Office 2019 Professional Plus'],
    ],
    '/products/microsoft-365-family-guenstiger-de': [
      ['microsoft-windows-11-home-microsoft-365-family', 'Windows 11 Home + Microsoft 365 Family'],
    ],
    '/products/microsoft-365-personal-guenstiger-de': [
      ['microsoft-windows-11-home-microsoft-365-personal', 'Windows 11 Home + Microsoft 365 Personal'],
    ],
    '/products/microsoft-windows-11-home-guenstiger-de': [
      ['microsoft-windows-11-home-microsoft-365-family', 'Windows 11 Home + Microsoft 365 Family'],
      ['microsoft-windows-11-home-microsoft-365-personal', 'Windows 11 Home + Microsoft 365 Personal'],
    ],
  };

  const mountGuenstigerBundleFallback = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    const bundles = fallbackBundles[path];
    if (!bundles) return;

    const confidence = document.querySelector('.rdr-product-confidence');
    const inner = confidence?.querySelector('.rdr-product-confidence__inner');
    if (!inner || confidence.querySelector('.rdr-bundle-offers')) return;

    const section = document.createElement('div');
    section.className = 'rdr-bundle-offers';
    section.innerHTML = `
      <div class="rdr-bundle-offers__header">
        <p>${bundleCopy.label}</p>
        <h2>${bundleCopy.title}</h2>
        <span>${bundleCopy.intro}</span>
      </div>
      <div class="rdr-bundle-offers__grid">
        ${bundles.map(([handle, title]) => `
          <a href="/products/${handle}" class="rdr-bundle-offer-card">
            <div class="rdr-bundle-offer-card__media"></div>
            <div class="rdr-bundle-offer-card__body">
              <small>${bundleCopy.type}</small>
              <strong>${title}</strong>
              <em>${bundleCopy.cta}</em>
            </div>
          </a>
        `).join('')}
      </div>
    `;
    inner.appendChild(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountGuenstigerBundleFallback, { once: true });
  } else {
    mountGuenstigerBundleFallback();
  }
})();
